import React from 'react';
import { Card, CardContent } from './ui/card';
import { Phone, Mail, MapPin } from 'lucide-react';
import { ContactForm } from './ContactForm';

export const ContactEvaluationSection = ({ isContactPage = false }) => {
  const images = window.aquifyConfig?.contactBoxImages || {};

  const cards = [
    {
      title: 'Call Us',
      text1: '516-729-9013',
      text2: 'Available 7 days a week',
      acfImage: images.call,
      fallbackSrc: `${process.env.PUBLIC_URL}/aquify-phone-support.png`,
      fallbackAlt: 'Aquify representative available by phone',
      href: 'tel:+15167299013',
      ariaLabel: 'Call Aquify at 516-729-9013'
    },
    {
      title: 'Email Us',
      text1: 'info@aquify.org',
      text2: 'Response within 2 hours',
      acfImage: images.email,
      fallbackSrc: `${process.env.PUBLIC_URL}/aquify-email-support.png`,
      fallbackAlt: 'Aquify representative responding to an email inquiry',
      href: 'mailto:info@aquify.org',
      ariaLabel: 'Email Aquify at info@aquify.org'
    },
    {
      title: 'Service Areas',
      text1: 'Long Island · NYC · Westchester',
      text2: 'Palm Beach · Broward County',
      acfImage: images.serviceAreas,
      fallbackSrc: `${process.env.PUBLIC_URL}/aquify-service-areas.png`,
      fallbackAlt: 'Aquify representative assisting customers across Aquify service areas'
    }
  ];

  const renderHeading = () => {
    if (isContactPage) {
      return (
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
          Request a <span className="text-[#1571BA]">Complimentary Water Evaluation</span>
        </h1>
      );
    }
    return (
      <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
        Request a <span className="text-[#1571BA]">Complimentary Water Evaluation</span>
      </h2>
    );
  };

  return (
    <section id="water-evaluation-form" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          {renderHeading()}
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Fill out the form below and a member of our team will contact you to confirm your appointment window.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {cards.map((card, idx) => {
            const CardWrapper = card.href ? 'a' : 'div';
            const wrapperProps = card.href ? { href: card.href, 'aria-label': card.ariaLabel } : {};
            
            return (
              <CardWrapper 
                key={idx} 
                {...wrapperProps}
                className={`rounded-xl border-2 border-gray-200 bg-white hover:border-[#50BAED] transition-colors duration-300 overflow-hidden shadow-sm flex flex-col ${card.href ? 'block focus:outline-none focus:ring-2 focus:ring-[#1571BA] focus:ring-offset-2 hover:-translate-y-1 transform' : ''}`}
              >
                <div className="w-full h-48 bg-slate-100 overflow-hidden relative">
                  {card.acfImage ? (
                    <img 
                      src={card.acfImage.src}
                      srcSet={card.acfImage.srcSet}
                      sizes={card.acfImage.sizes}
                      width={card.acfImage.width}
                      height={card.acfImage.height}
                      alt={card.acfImage.alt || card.title}
                      loading="lazy"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <img 
                      src={card.fallbackSrc}
                      alt={card.fallbackAlt}
                      loading="lazy"
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <div className="p-6 text-center flex-grow flex flex-col justify-center">
                  <h3 className="font-bold text-xl text-slate-900 mb-2">{card.title}</h3>
                  <p className="text-gray-700 font-medium">{card.text1}</p>
                  <p className="text-sm text-gray-500 mt-1">{card.text2}</p>
                </div>
              </CardWrapper>
            );
          })}
        </div>

        {/* Evaluation Request Form Container */}
        <div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactEvaluationSection;
